import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Commands from './commands';
import Queries from './queries';
import handlers from './handlers';
import Selection from './selection';
import History from './history';
import Columns from './columns';
import Records from './records';
import Fields from './fields';
import Views from './views';
import Data from './data';
import Dom from './dom';
export var QueriesPlugin = Queries;
export var CommandsPlugin = Commands;
export default function CorePlugin() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$plugins = options.plugins,
      plugins = _options$plugins === void 0 ? [] : _options$plugins;
  var commands = Commands(_objectSpread({}, Dom.commands, {}, Selection.commands, {}, Columns.commands, {}, Records.commands, {}, Fields.commands, {}, History.commands, {}, Views.commands, {}, Data.commands));
  var queries = Queries(_objectSpread({}, Dom.queries, {}, Selection.queries, {}, Columns.queries, {}, Records.queries, {}, Fields.queries, {}, History.queries, {}, Views.queries, {}, Data.queries));
  return [].concat(_toConsumableArray(plugins), [commands, queries, handlers]);
}